// extracted by mini-css-extract-plugin
export default {"page_list":"index_page_list_ezZ8z clearfix","current":"index_current_xkIp3"};